import styles from "./Section5.module.css";

const slideText = "PHYSICIANS SUCCESS PARTNERS";

export default function Section5() {
  return (
    <section className={styles.section} aria-label="Physicians Success Partners banner">
      <div className={styles.marquee}>
        <div className={styles.track}>
          <span className={styles.watermark}>{slideText}</span>
          <span className={styles.watermark} aria-hidden="true">
            {slideText}
          </span>
        </div>
      </div>
    </section>
  );
}
